import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    en: {
        translation: {
            logo_alt: 'American Express One AP',
            need_help: 'Need Help?',
            support_phone: '1-844-358-4025',
            multi_step_tracker: {
                login: 'Login',
                createpassword: 'Create Password',
                userinformation: 'User Information',
                companyinformation: 'Company Information',
                forgotpassword: 'Forgot Password'
            },
            intro: {
                welcome: 'Welcome to One AP!',
                welcome_intro: 'Your new One AP site is just a few steps away.',
                get_started: 'Here’s how to get started:',
                welcome_1_description: 'Provide user information',
                welcome_2_description: 'Provide company information',
                welcome_3_description: 'You will receive an email to access your new One AP site',
                welcome_4_description: 'Enroll your American Express card to begin making payments',
            },
            thanks: {
                almost_done: 'You’re almost done!',
                redirect_note: 'You will now be redirected to your One AP account.',
                contact_note: 'If you have any questions, please contact your American Express representative.',
                ao_email: 'We have sent an email to your Authorized Officer ({{email}}) with instructions on how to log in to One AP and accept the One AP Terms and Conditions.',
                ao_next_steps: 'Once the Terms and Conditions have been accepted, you will recieve an email with a link to your new One AP site.  Simply log in to your site and finish setting up your account.',
            },
            continue: 'Continue',
            back: 'Back',
            submit: 'Submit',
            login: {
                header: 'Log in to One AP',
                user_id: 'User ID',
                password: 'Password',
                password_placeholder: '**********',
                email_placeholder: 'name@company.com',
                remember_me: 'Remember Me',
                login_button: 'LOG IN',
                forgot_password: 'Forgot Password?',
                terms_of_service: 'Terms of Service',
                privacy_center: 'Privacy Center',
                ad_choices: 'AdChoices',
                security_center: 'Security Center',
                bad_credentials: 'Bad credentials',
                return_login: 'RETURN TO LOGIN',
                forgot_message: "Enter your email address and we'll send you a link to reset your password.",
                edit_email_address: 'EDIT EMAIL ADDRESS',
                no_mail: "I HAVEN'T RECEIVED AN EMAIL",
                no_mail_header: "Haven't received an email?",
                email_success_header: 'Email Successfully Sent',
                email_required: 'Email id is required',
                verify_mail: 'Please verify the email address is correct.',
                support_num: '1-844-358-4025',
                support_email: 'oneapsupport@aexp.com',
                verify_mail_body_1: 'Emails can take up to 15 minutes to send.',
                verify_mail_body_2: 'Please contact our support team to assist you.',
                instructions: 'Further instructions on how to reset your password have been sent to the email.',
                max_attempts_reached: 'your account has been locked because of too many failed login attempts',
                forgot_password_success_message: 'We sent you a Welcome email to {{email}} with further instructions. Select “Create your account” on the email to set a new password.',
                email_validation_failed: 'Email Validation Failed'
            },
            create_password: {
                header: 'Create Password for One AP',
                header_1: 'Create your new American Express ID',
                intro: 'One AP requires its own username and password, and is not related to any of you other American Express login credentials (@Work, AmericanExpress.com, etc.).',
                user_id: 'User ID:',
                user_id_1: 'User ID',
                user_id_hint: 'Your User ID is not case sensitive',
                user_id_exists: 'This User ID is already in use by another account.\n Please try again with a different User ID.',
                user_id_tooltip: 'This email address will be used to authenticate your account.',
                create_account: "Create Account",
                new_password: 'New Password',
                confirm_password: 'Confirm Password',
                password: 'Password',
                password_hint: 'Your password is case sensitive',
                setup_creds: '1. Set-up your credentials',
                password_match: 'Passwords must match',
                secure_account: '2. Secure your account',
                mobile_number: 'Mobile Phone Number',
                mobile_number_tooltip: 'Temporary account verification codes will be sent via SMS.',
                security_code: 'Security Code',
                security_code_hint: 'The security code can be used for account recovery.',
                secure_account_tooltip: 'The information will be used to reset your User ID or password.',
                email_address: 'Email Address',
                password_requirements_description: 'Your password must contain the following',
                password_requirements_1: 'At least 8 characters',
                password_requirements_2: 'At least one non-alphanumeric character, one number and non-alphanumeric character like @ # $ % & ( ) etc.',
                password_requirements_3: 'Must contain at least one letter, one number, one capital letter and one special character',
                password_requirements_4: 'Cannot contain spaces',
                password_requirements_5: 'Must not contain your User ID',
                password_requirements_6: 'Must contain 8 to 20 characters',
                security_code_hint_1: 'A Security Code should contain from 6 to 9 numbers',
                privacy_statement: `I agree that American Express may use my mobile phone number for User \n ID/password recovery and authentication purposes. For information on \n how we protect your privacy. Please read our`,
                modal: {
                    header: 'Password Set',
                    body: 'You have successfully set your new password.',
                },
            },
            verify_user: {
                header: 'Welcome to One AP',
                description: 'Please enter the first six digits of the phone number ending in - ',
                description2: ' to verify your account.',
                invaliderror : 'Invalid number entered. ',
                pleaseEnter6Digit: 'Please enter all 6 digits to verify your mobile number',
                error0: 'No attempts remaining. ',
                error1: '1 attempts remaining.',
                error2:'2 attempts remaining.',
                verify: 'Verify',
                notafamiliarphoneno: 'Not a familiar phone number?',
                pleasecontactyouradmin: 'Please contact your account administrator, {{createdByName}}, to ensure that the right phone number is used for your profile.',
                password_requirements_1: 'At least 8 characters',
                password_requirements_2: 'At least one non-alphanumeric character, one number and non-alphanumeric character like @ # $ % & ( ) etc.',
            },
            create: 'Create',
            user_info: {
                header: 'User Information',
                system_administrator_header: 'System Administrator',
                system_administrator_description: 'You are the individual responsible for setting up the One AP site, adding users and accounts, and receiving general account communications from One AP.',
                first_name: 'First Name',
                last_name: 'Last Name',
                middle_name: 'Middle Name (optional)',
                job_title: 'Job Title (optional)',
                business_email: 'Business Email Address',
                business_phone: 'Business Phone Number',
                work_phone: 'Work Phone Number (optional)',
                extension: 'Extension (optional)',
                cell_phone: 'Cell Phone (optional)',
                mobile_phone: 'Mobile Phone Number',
                ao_tooltip: 'American Express defines an Authorized Officer as an officer, partner, or representative of the company with authority to open accounts in the company’s name and bind the company to the One AP Terms & Conditions.',
                terms_consent_preamble: 'Are you authorized to accept the',
                terms_link_text: 'One AP Terms and Conditions',
                terms_link_url: 'https://icm.aexp-static.com/bpaa/oneap/one-ap-files/DAO/One-AP-Terms-and-Conditions-2025.pdf',
                terms_link_epilogue: 'on behalf of your company?',
                terms_explainer: 'To establish your account with One AP, an Authorized Officer of your company must accept the One AP Terms & Conditions.',
                terms_alternative: 'Please provide the contact information of an Authorized Officer from your company. They will receive an email prompting them to create a password in One AP and accept the One AP Terms & Conditions.',
                authorized_officer_header: 'Authorized Officer',
                authorized_officer_description: 'American Express defines an Authorized Officer as an officer, partner, or representative of the company with authority to open accounts in the company’s name and bind the company to the One AP Terms & Conditions.',
                at_least_one_letter: "Must contain at least one letter",
                duplicate_user_id: "This User ID is already in use. Please try another User ID.",
                user_id_length: "Must contain 5 to 20 characters",
                no_special_character : 'Cannot contain spaces or special characters \n (e.g. &, >. “, $, @)',
                password_check: 'The Password you have provided may be easily compromised. Please try again with a stronger password.'
            },
            simple_affirmative: 'Yes',
            simple_negative: 'No',
            errors: {
                firstname_required_field: 'First Name is required',
                lastname_required_field: 'Last Name is required',
                password_required: 'Password is required',
                password_invalid: 'Password is invalid,',
                password_invalid_1: 'Password is invalid',
                confirm_password_required: 'Confirm Password is required',
                confirm_password_invalid: 'Password is invalid,',
                middle_name_required: 'Middle Name is required',
                middle_name_invalid: 'Middle Name is invalid',
                userid_required: 'User ID is required',
                userid_invalid: 'User ID is invalid,',
                userid_invalid_1: 'User ID is invalid',
                privacy_statement_required: 'Privacy Statement is required',
                email_required: 'Business Email Address is required',
                email_required_forgot_password: 'To reset password, please enter your email address (leaving the password field empty). Then select the Forgot Password again. We will send you an email to set a new password.',
                invalid_phone: 'Business Phone Number is invalid',
                invalid_phone_number: 'Mobile Phone Number is invalid',
                invalid_work_number: 'Work Phone Number is invalid',
                password_confirmation: 'Password and Password Confirmation Must Match',
                error_boundary_header: 'An unexpected error occurred',
                error_boundary_note: 'If the problem persists, please contact your American Express representative.',
                invalid_fname: 'First Name is invalid',
                invalid_lname: 'Last Name is invalid',
                email_invalid: 'Business Email Address is invalid',
                email_invalid_forgot_password: 'Not a valid email',
                invalid_jobTitle: 'Job title is invalid',
                email_duplicate: 'Authorized Officer email address cannot be same as System Administrator email address',
                legalname_required_field: 'Legal Company Name is required',
                taxnum_required_field: 'Tax ID Number is required',
                address1_required_field: 'Street Address Line 1 is required',
                city_required_field: 'City is required',
                state_required_field: 'State is required',
                country_required_field: 'Country is required',
                postalcode_required_field: 'Postal Code is required',
                taxid_invalid: 'Tax ID Number is invalid',
                legalname_invalid: 'Legal Company Name can only contain letters, numbers, spaces, and these 3 special characters: -, &, and @.',
                dbaname_invalid: 'Doing Business As Name is invalid',
                mobile_required: 'Mobile Number is required',
                mobile_invalid: 'Mobile Number is invalid',
                security_code_required: 'Security code is required',
                security_code_invalid: 'Security code is invalid',
                zip_invalid: 'Postal Code is invalid',
                email_expire: 'Sorry, the link has expired. Please contact your American Express representative',
                expired_link: "We're having trouble finding the page you're looking for.",
                point_one : 'This could be because:',
                point_two: 'Here are a few things you can do:',
                text_1: 'The link has expired',
                text_2: 'The page has moved',
                text_3: 'The page no longer exists',
                submission_completed: 'You have already submitted the form. Please contact your American Express representative for any questions',
                street1_invalid: 'Street Address Line 1 is invalid',
                street2_invalid: 'Street Address Line 2 is invalid',
                city_invalid: 'City is invalid',
                addressHasPoBox: 'PO Box addresses are not allowed. Please enter a physical address',
                forty_characters_length_error: "You've exceeded the 40 character limit.",
                ten_characters_length_error: "You've exceeded the 10 character limit.",
                thirty_characters_length_error: "You've exceeded the 30 character limit.",
            },
            company: {
                company_info: 'Company Information',
                company_details: 'Company Details',
                company_contact_details: 'Company Contact Details',
                entity_name: 'Legal Company Name',
                tax_id: 'Tax ID Number',
                dba: 'Doing Business As Name (optional)',
                corporate_phone: 'Corporate Phone Number',
                extension: 'Extension (optional)',
                street_1: 'Street Address Line 1',
                street_2: 'Street Address Line 2 (optional)',
                city: 'City',
                state: 'State',
                zip: 'Postal Code',
                country: 'Country',
                accounting_details: 'Accounting Details',
                accounting_system: 'Accounting System',
                accounting_system_version: 'Accounting System Version',
                other_accounting_system_placeholder: 'Type your other accounting system here',
                other_accounting_system_verison_placeholder: 'Type your other accounting system version here',
                street_1_tooltip: 'Please enter the primary corporate mailing address for your business.',
                entity_name_tooltip: 'Please enter your primary business name exactly as it would appear in legal filings.  For example, American Express International Inc',
            },
            countries: {
                USA: 'United States'
            },
            confirmAddress: {
                title: 'Please Confirm Address',
                subtitle: 'We were unable to confirm the address entered. Please proceed with one of the following',
                originalAddress: {
                title: 'Original Address',
                button: 'Edit original'
            },
            recommendedAddress: {
                title: 'Recommended Address',
                button: 'Use recommended'
            },
            addressNotFound: {
                title: 'Address Not Found',
                content: 'We were unable to verify the address entered.',
                contentExtend: 'Please review and revise your address details.',
                button: 'Edit Address'
            }
            }, 
            success_screen: {
                title: 'American Express ID created',
                title_1: 'Success!',
                description: 'Use your new American Express ID to log in to One AP.',
                description_1: 'Your American Express ID is now connected with your One AP account. Please use it to log in \n to your One AP account in the future. ',
                button_text: 'Continue to Log In',
                button_text_1: 'Continue to One AP'
            },
            warning_screen: {
                oneApDisabledUser1: "You do not have access to One AP. Please reach out to your administrator for more details.",
                oneApDisabledUser2: "You can also contact us at ",
                oneApDisabledUser3:" or ",
                oneApDisabledUser4: " Mon through Fri 9:00 to 5:00 PM ET.",
                oneApRegistryFailed1: "We couldn’t link your account due to incorrect credentials. To lookup your credentials, click ",
                oneApRegistryFailed2: "Forgot User ID or Password",
                oneApRegistryFailed3: " on the login page and enter your existing One AP email address to retrieve.",
                oneApRegistryFailed4: "If you still need assistance, please contact us at ",
                oneApRegistryFailed5: ". Monday-Friday 8AM-6PM EST",
                oneIdentityInvalidPhone1: "We couldn't verify your mobile number as it's either missing or invalid.\n Please update your mobile number ",
                oneIdentityInvalidPhone2: "here",
                oneIdentityInvalidPhone3: ", then return to this tab and refresh the page to continue."
            },
            save_and_exit_modal: {
                confirmation: {
                    header: 'Do you want to save your progress?',
                    body: 'You can save your progress and we will provide you with a link to come back and finish later.',
                    negative: 'No, leave without saving',
                    positive: 'Yes, save',
                    logout: 'Logout',
                    redirectHeader: 'Redirect Error',
                    redirectContent: 'Unauthorized Please Logout'
                },
                saved: {
                    header: 'Work is saved!',
                    body: 'Return to this form at anytime using the link below. We have also emailed you the link for your convenience.',
                    success_message: 'Copied to clipboard',
                    close: 'Close',
                },
            },
            genericError: 'Something went wrong. Please try again later.',
        },
    },
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'en', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
